<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Usuários Apis</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovoUsuarioApi" />

    <SGPTabelaComponent
      v-if="listaDeUsuariosApis.length"
      :colunas="colunas"
      :dados="listaDeUsuariosApis"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>
    
    <SGPModalComponent
      v-if="abrirModal"
      tamanho="sm"
      titulo="Usuário Api"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioUsuarioApiComponent
        :tipoFormulario="tipoFormulario"
        :usuarioApi="usuarioApi"
      />
    </SGPModalComponent> 
    
    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />
    
    <SGPLoadingComponent v-if="loadingUsuarioApi" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioUsuarioApiComponent from '../components/FormularioUsuarioApiComponent.vue'

export default {
  components: { FormularioUsuarioApiComponent },
  name: 'UsuarioApiPage',

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      usuariosApisSelecionados: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      usuarioApi: {}
    }
  },
  created () {
    this.listarUsuariosApis();
  },
  computed: {
    ...mapGetters('usuariosApis', ['listaDeUsuariosApis','loadingUsuarioApi']),

    colunas () {
      return [
        {
          key: 'selecionar',
          label: '',
          sortable: false
        }, 
        {
          key: 'user.name',
          label: 'Usuário',
          sortable: false
        },
        {
          key: 'descricao',
          label: 'Descrição',
          sortable: false
        }
      ]
    }
  },

  methods: {
    ...mapActions('usuariosApis', ['listarUsuariosApis','excluirUsuariosApis']),

    gerenciadorDeSelecionados (selecionados) {
      this.usuariosApisSelecionados = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.usuarioApi = this.usuariosApisSelecionados[0];
      this.abrirModal = true;
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    confirmarDelecao () {
      this.excluirUsuariosApis(this.usuariosApisSelecionados);
      this.deletarDados = false;
    },

    adicionarNovoUsuarioApi () {
      this.usuarioApi = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    }

  }
}
</script>
